// extracted by mini-css-extract-plugin
export default {"tabsList":"Tabs_tabsList__+M3Pi","tab":"Tabs_tab__ZDCbJ","tabCount":"Tabs_tabCount__XGJBa","selected":"Tabs_selected__+XKvj"};